import Box from '@mui/material/Box';
import CircularProgress from "@mui/material/CircularProgress";
import React from "react";
import { useStyles } from "./Loading.styles";
export const Loading = (props) => {
    const classes = useStyles();
    return (React.createElement(Box, { component: 'div', sx: classes.root },
        React.createElement(CircularProgress, { size: props.size || 68 })));
};
export default Loading;
